import React, { useState } from 'react'

// Styles
import { BlogNavContainer, BlogNavLinkTitle, InnerDrawer, NavDropdownItem } from './style'

// Components
import Button from '../../../global/button'
import GlobalContainer from '../../../global/globalContainer'
import Typography from '../../../global/typography'

// Constants
import { ModuleNames } from '../../../../constants/componentNames.constants'

// Helpers
import {
  createLinkBasedOnType,
  createTextBasedOnType,
  isExternalURL,
} from '../../../../utils/link.utils'

import { UseCaseTypes } from '../../../../constants/blogUseCase'
import { arraysMatch } from '../../../../utils/functions.utils'

type BlogNavigationProps = {
  blogNav?: any
  pagePath?: string
  isNonNavigationPage?: boolean
  useCase?: string
}

type MenuGroupProps = {
  __typename: string
  groupName: string
  pages: any
  parentLink?: any
}

const DownCarat = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="BlogNavDropdown__Arrow">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.86006 11.0601C7.7654 10.9662 7.71216 10.8384 7.71216 10.7051C7.71216 10.5717 7.7654 10.4439 7.86006 10.3501L8.06006 10.1501C8.15413 10.0524 8.28447 9.99809 8.42006 10.0001H15.5801C15.7156 9.99809 15.846 10.0524 15.9401 10.1501L16.1401 10.3501C16.2347 10.4439 16.288 10.5717 16.288 10.7051C16.288 10.8384 16.2347 10.9662 16.1401 11.0601L12.3501 14.8501C12.2593 14.9467 12.1326 15.0016 12.0001 15.0016C11.8675 15.0016 11.7408 14.9467 11.6501 14.8501L7.86006 11.0601Z"
        fill="white"
      />
    </svg>
  )
}

const DownArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="BlogNav__Mobile-Menu-Arrow">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.81378 4.2165L8.04009 10.4428L14.2664 4.2165C14.5277 3.95453 14.9525 3.95453 15.2138 4.2165C15.4757 4.4778 15.4757 4.90258 15.2138 5.16388L8.51378 11.8639C8.25248 12.1258 7.8277 12.1258 7.5664 11.8639L0.866399 5.16388C0.604429 4.90258 0.604429 4.4778 0.866399 4.2165C1.1277 3.95453 1.55248 3.95453 1.81378 4.2165Z"
        fill="white"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="16"
        height="9">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.81378 4.2165L8.04009 10.4428L14.2664 4.2165C14.5277 3.95453 14.9525 3.95453 15.2138 4.2165C15.4757 4.4778 15.4757 4.90258 15.2138 5.16388L8.51378 11.8639C8.25248 12.1258 7.8277 12.1258 7.5664 11.8639L0.866399 5.16388C0.604429 4.90258 0.604429 4.4778 0.866399 4.2165C1.1277 3.95453 1.55248 3.95453 1.81378 4.2165Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)"></g>
    </svg>
  )
}

const XIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L13.4142 12L20.7071 19.2929C21.0976 19.6834 21.0976 20.3166 20.7071 20.7071C20.3166 21.0976 19.6834 21.0976 19.2929 20.7071L12 13.4142L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071C2.90237 20.3166 2.90237 19.6834 3.29289 19.2929L10.5858 12L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L12 10.5858L19.2929 3.29289Z"
        fill="white"
        fillOpacity="0.301961"
      />
    </svg>
  )
}

const BlogNavigation = ({
  blogNav,
  pagePath,
  isNonNavigationPage,
  useCase,
}: BlogNavigationProps) => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false)
  const [secondaryDrawerOpen, setSecondaryDrawerOpen] = useState(false)

  if (!useCase) useCase = UseCaseTypes.MAIN_BLOG

  const handleMobileNavClick = () => {
    setMobileDrawerOpen(!mobileDrawerOpen)
  }

  const handleSecondaryDrawerClick = () => {
    setSecondaryDrawerOpen(!secondaryDrawerOpen)
  }

  const handleSubscribeClick = (event: any) => {
    event.preventDefault()
  }

  if (blogNav && blogNav.menuGroups) {
    return (
      <BlogNavContainer data-cy="BlogNavigation" mobileDrawerOpen={mobileDrawerOpen}>
        <GlobalContainer className="BlogNav__Global-Container">
          <div className="BlogNav__Mobile-Menu-Switcher" onClick={handleMobileNavClick}>
            {mobileDrawerOpen ? <XIcon /> : <DownArrow />}

            <Typography className="BlogNav__Mobile-Menu-Title" type="bodyXS">
              {mobileDrawerOpen ? 'Close' : 'UiPath Blog'}
            </Typography>
          </div>
          <div className="BlogNav__Inner">
            <div className="BlogNav__Inner-Links">
              {blogNav.menuGroups.map((menuGroup: MenuGroupProps, i: number) => {
                if (menuGroup.__typename && menuGroup.__typename === ModuleNames.MENU_GROUP) {
                  return (
                    <NavDropdownItem
                      key={`BlogNavDropdown--${i}`}
                      className="BlogNav__Dropdown"
                      $secondaryDrawerOpen={secondaryDrawerOpen}>
                      <div
                        className="BlogNavDropdown__Arrow-Title"
                        onClick={handleSecondaryDrawerClick}>
                        <BlogNavLinkTitle type="label" className="BlogNavDropdown__Title">
                          {menuGroup.newGroupName}
                        </BlogNavLinkTitle>
                        <DownCarat />
                        <DownArrow />
                      </div>
                      <InnerDrawer
                        className="BlogNavDropdown__Links"
                        $secondaryDrawerOpen={secondaryDrawerOpen}>
                        {menuGroup.pages &&
                          menuGroup.pages.map((page: any, j: number) => {
                            let target
                            const linkHref = createLinkBasedOnType(page)
                            const linkTitle = createTextBasedOnType(page)
                            if (isExternalURL(linkHref)) {
                              target = '_blank'
                            } else {
                              target = '_self'
                            }
                            return (
                              <a
                                key={linkTitle}
                                className="BlogNavDropdown__Inner-Item"
                                href={linkHref}
                                rel="noopener"
                                target={target}>
                                <Typography
                                  type="bodyXS"
                                  className="BlogNavDropdown__Inner-Item-Title">
                                  {linkTitle}
                                </Typography>
                              </a>
                            )
                          })}
                      </InnerDrawer>
                    </NavDropdownItem>
                  )
                } else if (menuGroup.__typename && menuGroup.__typename === ModuleNames.TOPIC_CTA) {
                  let target
                  const linkHref = createLinkBasedOnType(menuGroup)
                  const linkTitle = createTextBasedOnType(menuGroup)
                  if (isExternalURL(linkHref)) {
                    target = '_blank'
                  } else {
                    target = '_self'
                  }

                  const blogRegex = /\/blog[^0-9]*/g
                  let pagePathMatch, linkMatch

                  if (pagePath) {
                    pagePathMatch = pagePath.match(blogRegex)

                    if (pagePathMatch && pagePathMatch[0][pagePathMatch[0].length - 1] === '/') {
                      pagePathMatch[0] = pagePathMatch[0].slice(0, -1)
                    }
                  }

                  if (linkHref) {
                    linkMatch = linkHref.match(blogRegex)
                  }

                  let isActiveLink = false

                  if (linkMatch && linkMatch[0] && pagePathMatch && pagePathMatch[0]) {
                    if (typeof pagePathMatch[0] === 'string' && typeof linkMatch[0] === 'string') {
                      if (!isNonNavigationPage) {
                        let splitPagePath = pagePathMatch[0].split('/')
                        const splitLink = linkMatch[0].split('/')
                        if (splitPagePath.length === 4) {
                          splitPagePath.pop()
                        }

                        const linksMatch = arraysMatch(splitPagePath, splitLink)

                        if (linksMatch) {
                          isActiveLink = true
                        }
                      } else if (isNonNavigationPage && linkMatch[0] === '/blog') {
                        // Make blog tab active for author pages
                        isActiveLink = true
                      }
                    }
                  }

                  return (
                    <BlogNavLinkTitle
                      type="label"
                      key={`BlogNav__CTA--${i}`}
                      className={isActiveLink ? `BlogNav__CTA--Active` : `BlogNav__CTA--Inactive`}>
                      <a
                        href={linkHref}
                        className="NavDropdownItem__Link"
                        rel="noopener"
                        target={target}>
                        {linkTitle}
                      </a>
                    </BlogNavLinkTitle>
                  )
                }
              })}
            </div>
            {useCase === UseCaseTypes.MAIN_BLOG && (
              <Button
                icon={true}
                text="Subscribe"
                type="text-link"
                size="small"
                theme="light"
                onClick={handleSubscribeClick}
                className="BlogNav__Subscribe SubscribeModal__Trigger"
              />
            )}
          </div>
        </GlobalContainer>
      </BlogNavContainer>
    )
  } else {
    return null
  }
}

export default BlogNavigation
